import { UPDATE_NOTIFICATIONS } from "redux/constants/Menu";

const initMenu = {
	empresasComErros: 0,
	veiculosPrecificacao: 0,
	vistoriasPendentes: 0,
	veiculosComPendencias: 0,
	veiculosPreCadastro: 0,
};

const menu = (state = initMenu, action) => {
	switch (action.type) {
		case UPDATE_NOTIFICATIONS:
			return {
				...state,
				empresasComErros: action.empresasComErros || 0,
				veiculosPrecificacao: action.veiculosPrecificacao || 0,
				vistoriasPendentes: action.vistoriasPendentes || 0,
				veiculosComPendencias: action.veiculosComPendencias || 0,
				veiculosPreCadastro: action.veiculosPreCadastro || 0,
			};
		default:
			return state;
	}
};

export default menu;
